import { faPen } from '@fortawesome/pro-solid-svg-icons'
import { Input } from 'antd'

import FormItem from '../../../../Components/shared/Forms/FormItem'

const MetadataFields = ({ className = '', disabled = false, metadataFields, values, onChange }) => {
  const handleMetadataChange = fieldName => e => {
    const { target } = e

    onChange(fieldName, target.value)
  }

  return (
    <div className={className}>
      {metadataFields.map((field) =>
        <FormItem key={field.id} icon={faPen} label={field.name} required={field.isMandatory}>
          <Input
            disabled={disabled}
            value={values[field.name]}
            onChange={handleMetadataChange(field.name)}
          />
        </FormItem>
      )}
    </div>
  )
}

export default MetadataFields
